var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16082_26788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11.5007C8.05867 11.5007 9.74995 9.86928 9.74995 7.77526C9.74995 7.26118 9.72382 6.71011 9.43888 5.85363C9.15393 4.99718 9.09653 4.88663 8.79523 4.35771C8.6665 5.43708 7.97775 5.88693 7.80277 6.02138C7.80277 5.88151 7.38612 4.33471 6.7544 3.40921C6.13425 2.50073 5.29085 1.90471 4.79633 1.50073C4.79633 2.26817 4.58047 3.40921 4.27135 3.99058C3.96222 4.57196 3.90417 4.59313 3.51805 5.02578C3.13195 5.45843 2.95473 5.59206 2.63185 6.11701C2.30899 6.64198 2.25 7.34118 2.25 7.85526C2.25 9.94928 3.94132 11.5007 6 11.5007Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16082_26788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.e07c28cc58135ed680aa16a664215064.svg";
export { ForwardRef as ReactComponent };